<div class="error-page">
    <div class="page-content">
        <img priority src="https://cdn.illpeoplemusic.com/imges/imgs/icons/error_404.svg" alt="error_404" loading="lazy">
        <h1 class="heading">Page not Found</h1>
        <p>We're sorry. The page you requested could not be found.
            Please go back to the homepage.
        </p>
        <button class="back-button" (click)="goBack()">Go Back</button>
    </div>
</div>
